import { VolopImportedType } from 'api/volops';

export const VOLOP_IMPORTED_TYPE_MAP: Record<VolopImportedType, string> = {
  DONORS_CHOOSE: 'DonorsChoose.org',
  KIVA: 'Kiva',
  NYCPARKS: 'NYC Parks',
  GLOBAL_GIVING: 'GlobalGiving',
  VOLUNTEERMATCH: 'VolunteerMatch',
  MOVE_ON: 'MoveOn',
  POINTS_OF_LIGHT: 'Points of Light',
  AARP: 'AARP',
  DO_SOMETHING: 'DoSomething',
  NEWYORKCARES: 'New York Cares',
  VOLUNTEERGOV: 'Volunteer.gov',
  CITIZENCONNECT: 'Citizen Connect',
  CARE2: 'Care2',
  GRAPEVINE: 'Grapevine',
};
